import { FC, useRef, useState } from 'react';
import OrderBook from './OrderBook';
import FlightBookSkeleton from './FlightBookSkeleton';
import useFlightBook from 'hooks/useFlightBook';
import MultiBookSummary from './MultiSummary';
import ExpiredToken from 'components/shared/ExpiredToken';
import usePageInMemory from 'hooks/usePageInMemory';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { saveScreenshot } from 'utils/utils';
import { Pax } from 'ts/flight/interfaces/FlightBookResponse';
import { ListOFCatalogPrice } from 'ts/flight/interfaces/FlightDetailsResponse';
import { useLocation, useSearchParams } from 'react-router-dom';
import { updatePaymentBlock } from 'services/flight';
import { useTranslation } from 'react-i18next';
import { faArrowCircleLeft, faSearch } from '@fortawesome/free-solid-svg-icons';
import Button from 'components/ui/Button/Button';
const MultiFlightBookPage: FC = () => {
  const { response, bounds, boundsPair, setResponse } = useFlightBook();
  const bookRef = useRef<HTMLDivElement>(null);
  const [addPrice, setAddPrice] = useState(0);
  const [paxes, setPaxes] = useState<Pax[]>([]);
  const location = useLocation();
  const idbKey = location.pathname + location.search;
  const { onClickBack, onClickSearch } = usePageInMemory(idbKey, () => {});
  const [couponCode, setCouponCode] = useState('');
  const [urlParams] = useSearchParams();
  const { i18n, t } = useTranslation();

  useGetPage('Flights/Book');
  const onSubmit = async () => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    await saveScreenshot(bookRef.current, 'Book', 'Flights');
  };

  const getBags = (type: 'baggageFlightDetails' | 'baggageFlightDetailsPair') => {
    const bags = response?.bookingModel?.[type]?.bookFareAndBaggageFlights
      ?.map((fl) => [
        ...(fl.outbound?.listOfCatalogPrice || []),
        ...(fl.inbound?.listOfCatalogPrice || []),
      ])
      .flat();
    return paxes
      ?.map((pax) => [...(pax.baggageOutboundArr || []), ...(pax.baggageInboundArr || [])])
      .flat()
      .map((id) => bags?.find((bag) => bag.code === id))
      .filter((bag) => !!bag) as ListOFCatalogPrice[];
  };

  const onClickApply = async () => {
    const res = await updatePaymentBlock({
      packageCurrency: response?.bookingModel?.currency || '',
      sourcePrice: response?.bookingModel?.credit2000PaymentInfo?.fullPriceInShekel || 0,
      addPrice: parseInt(couponCode || '0') + addPrice,
      searchToken: urlParams.get('searchToken') || '',
      lang: i18n.language,
    });

    if (!response?.bookingModel || !res) return;
    setResponse({
      ...response,
      bookingModel: {
        ...response.bookingModel,
        credit2000PaymentInfo: res.credit2000PaymentInfo,
      },
    });
  };

  return (
      <div className="details-wrapper" ref={bookRef}>
        {!!response?.bookingModel?.flight && (
          <div className="flex-column">
            <div className="mb-20 default-shadow flex-between dyn-change-header">
              <Button
                title={t('back')}
                icon={faArrowCircleLeft}
                onClick={() => onClickBack('flight', 'details')}
                className="btn btn-link"
              />
              <Button
                title={t('search.new')}
                icon={faSearch}
                onClick={() => onClickSearch('flight', '/flights')}
                className="btn btn-link"
              />
            </div>
            <div className="flex-between w100p">
              <OrderBook
                isMulti={true}
                bookingModel={response.bookingModel}
                restrictOptionalService={response.restrictOptionalService}
                restrictOptionalServicePair={response.restrictOptionalServicePair}
                privileges={response.privilegesInfo}
                onSubmit={onSubmit}
                couponCode={couponCode}
                setAddPrice={setAddPrice}
                addPrice={addPrice}
                onUpdateCredit={(cred) =>
                  setResponse({
                    ...response,
                    bookingModel: { ...response.bookingModel!, credit2000PaymentInfo: cred },
                  })
                }
                paxes={paxes}
                setPaxes={setPaxes}
              />
              <MultiBookSummary
                outFlight={response?.bookingModel.flight}
                inFlight={response?.bookingModel.flightPair}
                outbounds={bounds}
                inbounds={boundsPair}
                addPrice={addPrice}
                outBags={getBags('baggageFlightDetails')}
                inBags={getBags('baggageFlightDetailsPair')}
                setCouponCode={setCouponCode}
                couponCode={couponCode}
                onClickApply={onClickApply}
              />
            </div>
          </div>
        )}

        {response?.sessionExpired && <ExpiredToken storePath="flight" />}

        {!response && <FlightBookSkeleton />}
      </div>
  );
};

export default withErrorBoundary(MultiFlightBookPage, 'MultiFlightBookPage');
